// src/api/publicApiTokens.ts
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

/**
 * 公開API Token の型定義
 */
export interface PublicApiToken {
  id: string;
  token: string;
  workspaceId: string;
  allowedOrigins: string[];
  allowAnyOrigin: boolean;
  isActive: boolean;
  createdAt: any;
  createdBy: string;
  lastUsedAt: any | null;
  note?: string;
  stats?: {
    totalRequests: number;
    lastOrigin: string | null;
  };
}

/**
 * Token生成リクエスト
 */
export interface GenerateTokenRequest {
  workspaceId: string;
  allowedOrigins?: string[];
  note?: string;
}

/**
 * Token更新リクエスト
 */
export interface UpdateTokenRequest {
  tokenId: string;
  allowedOrigins?: string[];
  isActive?: boolean;
  note?: string;
}

/**
 * Token削除リクエスト
 */
export interface DeleteTokenRequest {
  tokenId: string;
}

/**
 * Token一覧取得リクエスト
 */
export interface ListTokensRequest {
  workspaceId: string;
}

/**
 * Token生成レスポンス
 */
export interface GenerateTokenResponse {
  tokenId: string;
  token: string;
  workspaceId: string;
  allowedOrigins: string[];
  createdAt: any;
}

/**
 * Token生成
 */
export async function generatePublicApiToken(
  request: GenerateTokenRequest
): Promise<GenerateTokenResponse> {
  const callable = httpsCallable(functions, 'generatePublicApiTokenFn');
  const result = await callable(request);
  return result.data as GenerateTokenResponse;
}

/**
 * Token更新
 */
export async function updatePublicApiToken(
  request: UpdateTokenRequest
): Promise<{ success: boolean; tokenId: string }> {
  const callable = httpsCallable(functions, 'updatePublicApiTokenFn');
  const result = await callable(request);
  return result.data as { success: boolean; tokenId: string };
}

/**
 * Token削除
 */
export async function deletePublicApiToken(
  request: DeleteTokenRequest
): Promise<{ success: boolean; tokenId: string }> {
  const callable = httpsCallable(functions, 'deletePublicApiTokenFn');
  const result = await callable(request);
  return result.data as { success: boolean; tokenId: string };
}

/**
 * Token一覧取得
 */
export async function listPublicApiTokens(
  request: ListTokensRequest
): Promise<{ tokens: PublicApiToken[] }> {
  const callable = httpsCallable(functions, 'listPublicApiTokensFn');
  const result = await callable(request);
  return result.data as { tokens: PublicApiToken[] };
}

